module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1001-bcf0b0364e4c5357b599d8923907c9c6.png";